import React from "react";
import { Row, Col, Space } from 'antd';

const ConsumerShowApplicationId = () => {
    const applicationId = localStorage.getItem("ApplicationIdText");

    return (
        <Row
            align="middle"
            justify="end"
            style={{ width: '100%' }}
        >
            <Col
                xs={24}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    // justifyContent: 'flex-end',
                    paddingRight: 24,
                }}
            >
                <Space size="middle">
                    <div className="fRight baseAlign">
                        <strong className="f16">Application ID:</strong>
                        <span className="ml5 f16">{applicationId ? applicationId : "N/A"}</span>
                    </div>
                </Space>
            </Col>
        </Row>
    );
}

export default ConsumerShowApplicationId;